$(document).ready(function () {
    // let isClickedTabHeader = false;
    // let isChangedActiveTabHeaderItem = false;
    // $(".tab-header").on('change', function () {
    //     const index = $(this).find("option:selected").index();
    //     let tabContent = $(this).closest(".tab").find(`.tab-pannel:nth-child(${index + 1})`);
    //     if (tabContent.length > 0) {
    //         $(this).closest(".tab").find('.tab-pannel.active').removeClass("active");;
    //         tabContent.addClass("active");
    //     } else {
    //         tabContent = $(this).closest(".image-list-tab").find(`.image-list-tab-panel:nth-child(${index + 1})`);
    //         $(this).closest(".image-list-tab").find('.image-list-tab-panel.active').removeClass("active");;
    //         tabContent.addClass("active");
    //     }
    //     isChangedActiveTabHeaderItem = true;
    //     $(this).blur();
    //     isChangedActiveTabHeaderItem = false;
    // });
    // $(".tab-header").on('blur',function(){
    //     if(!isChangedActiveTabHeaderItem) {
    //         isClickedTabHeader = false;
    //     }
    // });
    // $(".tab-header").on('click',function(){
    //     if(!isClickedTabHeader) {
    //         isClickedTabHeader = true;
    //     } else {
    //         $(this).blur();
    //     }
    // });

    const imageLists = document.querySelectorAll(".image-list-container .image-list");
    for (const imagelist of imageLists) {
        let count = parseInt(imagelist.getAttribute('item-count'));
        if (isNaN(count)) {
            count = 5;
        }
        const enableSiderOnMobile = !imagelist.classList.contains("for_only_desktop");
        if(imagelist.id !== '') {
            if(!enableSiderOnMobile) {
                new Swiper(`#${imagelist.id}`, {
                    slidesPerView: count,
                    breakpoints: {
                        0: {
                            enabled: false,
                            slidesPerView: 3
                        },
                        768: {
                            enabled: true,
                            slidesPerView: count - 0.5
                        },
                        1023: {
                            slidesPerView: count
                        }
                    }
                });
            } else {
                new Swiper(`#${imagelist.id}`, {
                    slidesPerView: count,
                    breakpoints: {
                        0: {
                            slidesPerView: count - 2
                        },
                        424: {
                            slidesPerView: count - 1.5
                        },
                        600: {
                            slidesPerView: count - 1
                        },
                        768: {
                            slidesPerView: count - 0.5
                        },
                        1023: {
                            slidesPerView: count
                        }
                    }
                });
            }
        }
    }

    document.querySelectorAll(".product-list.mobile").forEach(productList=>{
        let desktop_item_count = parseInt(productList.getAttribute('desktop-item-count'));
        let mobile_item_count = parseFloat(productList.getAttribute('mobile-item-count'));
        if (isNaN(desktop_item_count)) {
            desktop_item_count = 5;
        }
        if (isNaN(mobile_item_count)) {
            mobile_item_count = 1.5;
        }
        new Swiper(`#${productList.id}`, {
            spaceBetween: 0,
            freeMode: {
                momentum: false,
            },
            breakpoints: {
                0: {
                    slidesPerView: mobile_item_count,
                    // enabled: true,
                },
                480: {
                    slidesPerView: desktop_item_count - (desktop_item_count - mobile_item_count) / 4 * 3,
                    // enabled: true,
                },
                600: {
                    slidesPerView: desktop_item_count - (desktop_item_count - mobile_item_count) / 4 * 2,
                    // enabled: true,
                },
                768: {
                    slidesPerView: desktop_item_count - (desktop_item_count - mobile_item_count) / 4,
                    // enabled: true,
                },
                1023: {
                    slidesPerView: desktop_item_count,
                    // enabled: true,
                },
                1024:{
                    slidesPerView: 'auto',
                    // enabled: false,
                }
            }
        });
    });

    
  // Set header height as CSS custom property
  function setHeaderHeight() {
    const header = document.querySelector('.shopify-section-group-header-group.section--header');
    if (header) {
      const headerHeight = header.offsetHeight;
      document.body.style.setProperty('--header-height', `${headerHeight}px`);
    }
  }

  // Run on load
  setHeaderHeight();

  // Update on resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      setHeaderHeight();
    }, 250);
  });

  // Update when header might change (e.g., after content loads)
  if ('ResizeObserver' in window) {
    const header = document.querySelector('.shopify-section-group-header-group.section--header');
    if (header) {
      const headerObserver = new ResizeObserver(() => {
        setHeaderHeight();
      });
      headerObserver.observe(header);
    }
  }
});